import { GetAllJoints } from "@project-rouge/rg-core";
import { addCornerCores } from "./index182.js";
import { hasCornerCore } from "./index177.js";
import { getActiveBuildings } from "./index183.js";
const pipeAddCornerCores = ([parent, { buildingIds, aggProps }]) => {
  const dataset = aggProps.dataset;
  const buildings = getActiveBuildings(parent, aggProps);
  for (const building of buildings) {
    if (buildingIds && !buildingIds.includes(building.uuid))
      continue;
    const joints = GetAllJoints(building.data.anatomy);
    const allCores = [];
    for (const j of joints) {
      if (!hasCornerCore(j))
        continue;
      allCores.push(...addCornerCores(j, dataset));
    }
    building.children = building.children.concat(allCores);
  }
  return [parent, void 0];
};
export {
  pipeAddCornerCores
};
//# sourceMappingURL=index87.js.map
